import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function AziendeBuyerValutazioni() {

    DataTable.use(DT);

    const { id } = useParams();
    const client = getWebClient();
    const [buyerName, setBuyerName] = useState('');
    const [averageStars, setAverageStars] = useState('-');

    const columns = [
        { data: 'ragioneSociale' },
        {
            data: 'stelle',
            width: '100px',
            orderable: false
        },
    ];

    const options = {
        language: getDataTablesLanguage(),
        paging: false,
    };

    const [tableData, setTableData] = useState([]);   

    function buyerGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/aziendebuyer/${id}`).then((response) => {
                resolve(response.data);
            });
        });
    }

    function valutazioniGetPromise() {
        return new Promise((resolve) => {
            client.get(`/api/aziendebuyervalutazioni/${id}`).then((response) => {
                resolve(response.data);
            });
        });
    }

    useEffect(() => {

        Promise.all([buyerGetPromise(), valutazioniGetPromise()])

            .then((results) => {
                setBuyerName(results[0].ragioneSociale);
                setTableData(results[1]);

                if (!results[1] || results[1].length === 0) {
                    setAverageStars('-');
                } else {
                    const sum = results[1].reduce((accumulator, currentObject) => {                    
                        return accumulator + currentObject.stelle;
                    }, 0);
                    const average = sum / results[1].length;
                    setAverageStars(average);
                }

            })

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <style
                dangerouslySetInnerHTML={{
                    __html: "tr.text-danger td {color: inherit;} tr.text-danger td div a {color: inherit;}"
                }}
            />

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <div className="row">
                    <div className="col">
                        <h4>Valutazioni ricevute da {buyerName} [media: {averageStars}]</h4>
                    </div>
                </div>
            </div>

            <div className="container">
                <DataTable data={tableData} columns={columns} options={options} className="table">
                    <thead>
                        <tr>
                            <th>Ragione sociale seller</th>
                            <th>Stelle</th>                         
                        </tr>
                    </thead>
                </DataTable>
                <br></br>
                <br></br>
            </div>

        </>
    )
}
